import { Link } from "react-router-dom";
import { guEvents } from "@/mocks/events";

const formatLikes = (value: number) =>
  value >= 10000 ? `${(value / 10000).toFixed(1)}万` : `${value}`;

export default function CommentHighlights() {
  const picks = guEvents.slice(0, 3).map((item) => ({ event: item, comment: item.highlight }));

  return (
    <section id="comments" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600">
              COMMENT OF THE DAY
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              评论区名场面
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              比起事件本身，这几条评论才是真正把瓜推上热搜的原因。翻车现场、神评暴击、路人锐评，一次看全。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {picks.map(({ event, comment }, index) => (
            <article
              key={event.id}
              className="gu-rise flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-black ${
                    index === 0
                      ? "bg-primary-500 text-background-50"
                      : index === 1
                        ? "bg-accent-500 text-foreground-950"
                        : "bg-secondary-500 text-background-50"
                  }`}
                >
                  {comment.author.slice(0, 1)}
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-1.5 text-sm font-bold text-foreground-950">
                    {comment.author}
                    <span className="rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-bold text-primary-700">
                      {comment.badge}
                    </span>
                  </span>
                  <span className="block text-xs text-foreground-500">{comment.time}</span>
                </span>
              </div>

              <p className="mt-4 flex-1 font-heading text-base leading-relaxed text-foreground-900">
                “{comment.content}”
              </p>

              <div className="mt-4 flex items-center justify-between border-t border-background-300 pt-3">
                <span className="flex items-center gap-1 text-xs font-semibold text-foreground-600">
                  <i className="ri-thumb-up-line text-primary-600" />
                  {formatLikes(comment.likes)} 赞同
                </span>
                <Link
                  to={`/event/${event.id}`}
                  className="flex cursor-pointer items-center gap-1 text-xs font-semibold text-secondary-700 transition-colors hover:text-secondary-900"
                >
                  {event.categoryLabel}
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}